import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from '../utils/constants';
import Modal from "react-modal";
import StepHeader from '../screens/registration/stepHeader'
import ExhibitorTopMenu from "../common_components/exhibitor_module_topmenu";


Modal.setAppElement("#root");


// {head,subHeader}
const ExhibitorHeader = () => {

    const history = useNavigate();
    const [isLoading, setLoader] = useState(false);


    const loadScripts = () => {
        // This array contains all the files/CDNs 
        // const dynamicScripts = [
        //   'js/jquery.sticky.js',
        //   'js/metisMenu.min.js',
        //   'js/metisMenu-active.js',
        //   'js/main.js',
        //   'js/azia.js'
        // ];

        // for (let i = 0; i < dynamicScripts.length; i++) {
        //   const node = document.createElement('script');
        //   node.src = dynamicScripts[i];
        //   node.type = 'text/javascript';
        //   node.async = false;
        //   document.getElementsByTagName('head')[0].appendChild(node);
        // }
    }

    useEffect(() => {
        loadScripts();
        // console.log("sessionStorage.getItem(sessionExhibitorDrawerData)------->", sessionStorage.getItem(sessionExhibitorDrawerData))

    }, []);



    const onLogoutClick = () => {
        localStorage.clear();
        // history.push('/login');
    }

    const openPdf = () => {
        var URL = userManualDownloadUrl /* http://0.0.0.0:8000/ or http://127.0.0.1:8000/; */
        window.open(URL, null);
    }

    return (
        <>
            {isLoading ? (
                <Loader></Loader>
            ) : (
                null
            )}
            <>
                {/* app-Header */}
                <div className="app-header header sticky app-heder-with-logo" style={{ zIndex: '1 !important' }}>
                    <div className="container-fluid main-container">
                        <div className="d-flex" style={{marginTop:'-1.1rem'}}>
                            {/*  <a aria-label="Hide Sidebar" class="app-sidebar__toggle" data-bs-toggle="sidebar" href="javascript:void(0)"><i class="fa fa-bars"></i></a>  */}
                            {/* sidebar-toggle*/}
                            <h5 className="exbheader">
                                {" "}
                                {sessionStorage.getItem('ExhibitionFromDateSS')} - {sessionStorage.getItem('ExhibitionToDateSS')} <br />
                                {sessionStorage.getItem('ExhibitionAddressSS')}{" "}<br></br>
                                <span className='mt-1'> For new corporate site please <a href='https://corporate.india-itme.com' target='blank' className='header-login-a'>click here</a></span>
                            </h5>
                            <div className="right-logo-logo">
                                <img src="images/itme-right-logo.png" style={{ width: 70 }} />
                            </div>
                            <p />
                            <a className="logo-horizontal" href="index.html">
                                <img
                                    src="images/itme-right-logo.png"
                                    className="header-brand-img light-logo1"
                                    alt="logo"
                                />
                            </a>

                            {/* LOGO */}
                            {/*  <div class="main-header-center ms-3 d-none d-lg-block">
                      <input type="text" class="form-control" id="typehead" placeholder="Search for results...">
                      <button class="btn px-0 pt-2"><i class="fe fe-search" aria-hidden="true"></i></button>
                  </div> */}
                            <div className="d-flex order-lg-2 ms-auto header-right-icons">
                                {/* SEARCH */}
                                <button
                                    className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#navbarSupportedContent-4"
                                    aria-controls="navbarSupportedContent-4"
                                    aria-expanded="false"
                                    aria-label="Toggle navigation"
                                >
                                    <span className="navbar-toggler-icon fe fe-more-vertical" />
                                </button>
                                <div className="navbar navbar-collapse responsive-navbar p-0">
                                    <div
                                        className="collapse navbar-collapse"
                                        id="navbarSupportedContent-4"
                                    >
                                        <div className="d-flex order-lg-2">
                                            <div className="dropdown d-lg-none d-flex">
                                                <a
                                                    href="javascript:void(0)"
                                                    className="nav-link icon"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <i className="fe fe-search" />
                                                </a>
                                                <div className="dropdown-menu header-search dropdown-menu-start">
                                                    <div className="input-group w-100 p-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Search...."
                                                        />
                                                        <div className="input-group-text btn btn-primary">
                                                            <i className="fa fa-search" aria-hidden="true" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex country">
                                                <a className="nav-link icon text-center">
                                                    {/* <span class="fs-16 ms-2 d-none d-xl-block">Admin</span> */}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginRight: '4rem' }}>
                            <marquee
                                style={{ fontSize: "17px", color: "#000", fontWeight: "500", marginTop: '-1rem' }}
                                behavior="scroll"
                                direction="left"
                                scrollamount="5"
                                onMouseOver={(e) => e.target.stop()}
                                onMouseOut={(e) => e.target.start()}
                            >
                                <b>Disclaimer and Ownership:</b> {disclaimer}
                            </marquee>
                        </div>
                    </div>
                    <div className="user-sle" style={{ marginTop: '-0.5rem' }}>
                        {/* <div className="user-sle1">
                            <spa style={{ width: '180px', display: "inline-block", textTransform: "uppercase" }}>
                                <i className="fa fa-building-o mr-1" />   {sessionStorage.getItem('sessionHeaderData') != null &&
                                    JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['CompanyName']}
                            </spa>
                        </div> */}
                        <div className="user-sle2 mt-1" style={{ display: "flex" }}>

                            <div class="cut-text">
                                <i className="fa fa-user-o" aria-hidden="true" style={{ marginRight: '10px' }} />{" "}
                                <span style={{ textTransform: "uppercase" }}>
                                    {JSON.parse(sessionStorage.getItem('loginDataSS'))['CompanyName'] != null &&
                                        JSON.parse(sessionStorage.getItem('loginDataSS'))['CompanyName']}</span>
                            </div>

                            <i className="fa fa fa-list exh-header" aria-hidden="true" /> <span>
                                {sessionStorage.getItem('sessionHeaderData') != null &&
                                    JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['StallTypeName']}
                            </span>
                            <i className="fa fa-th-large exh-header" aria-hidden="true" /> <span>-</span>
                            <i className="fa fa-th exh-header" aria-hidden="true" />{" "}
                            <span>
                                {sessionStorage.getItem('sessionHeaderData') != null &&
                                    JSON.parse(sessionStorage.getItem('sessionHeaderData'))[0]['StallArea']}(m<sup>2</sup>)
                            </span>
                        </div>
                        <div className="mt-1" style={{ float: 'right' }}>
                            <span>
                                <Link to={'/Change_Password'}>
                                    <i class="fa fa-cog"></i> Change Password
                                </Link>
                            </span>
                        </div>
                    </div>


                </div>

                {/* /app-Header */}
            </>

        </>
    );
}
export default ExhibitorHeader;

